import { createSelector } from '@ngrx/store';
import { TransactionStatus } from '@rd/types';
import {
  getRewardsProgramPreferenceState,
  getRewardsProgramState,
} from '../reducers';

export const getRewardsPrograms = createSelector(
  getRewardsProgramState,
  (state) => state.rewardsPrograms,
);

export const getRewardsProgramsPreference = createSelector(
  getRewardsProgramPreferenceState,
  (state) => state.rewardsProgramPreference,
);

export const getRewardsProgramsPreferenceLoadingSuccess = createSelector(
  getRewardsProgramPreferenceState,
  (state) =>
    state.rewardsProgramPreferenceLoading.loading === TransactionStatus.SUCCESS,
);

export const getRewardsProgramsPreferenceLoadingFailed = createSelector(
  getRewardsProgramPreferenceState,
  (state) =>
    state.rewardsProgramPreferenceLoading.loading === TransactionStatus.FAIL,
);

export const getRewardsProgramsPreferenceLoading = createSelector(
  getRewardsProgramPreferenceState,
  (state) =>
    state.rewardsProgramPreferenceLoading.loading === TransactionStatus.LOADING,
);
